import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';
import Order from '@/views/Order.vue';
import List from '@/views/List.vue';
import Cart from '@/views/Cart.vue';
import FinishOrder from '@/views/FinishOrder.vue';
import OrderStatus from '@/views/OrderStatus.vue';
import StatusDetail from '@/views/StatusDetail.vue';
import ProductIntro from '../views/Productintro.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/index',
    name: 'List',
    component: List,
    // children: [
    //   {
    //     path: ':id',
    //     name: 'product',
    //     component: ProductIntro,
    //   },
    // ],
  },
  {
    path: '/index/:id',
    name: 'product',
    component: ProductIntro,
  },
  {
    path: '/cart',
    name: 'Cart',
    component: Cart,
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
  },
  {
    path: '/checkout',
    name: 'FinishOrder',
    component: FinishOrder,
  },
  {
    path: '/status',
    name: 'OrderStatus',
    component: OrderStatus,
  },
  {
    path: '/statusdetail/:orderid',
    name: 'StatusDetail',
    component: StatusDetail,
  },
  {
    path: '/:title',
    redirect: { name: 'List' },
  },
  {
    path: '/',
    redirect: { name: 'List' },
  },

  // {
  //   path: '/:category',
  //   name: 'Intro',
  //   component: Intro,
  // },
  // {
  // path: '/about',
  // name: 'About',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  base: '/dali',
  routes,
  // scrollBehavior(to) {
  //   if (to.hash) {
  //     console.log('滾動');
  //     return {
  //       // selector: to.hash,
  //       // el: '#pro',
  //       // offset: { x: 0, y: 500 },
  //     };
  //   }
  //   return { x: 0, y: 0 };
  // },\
});

export default router;
